/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Settings_Photo_Too_LargeInputs */



/**
* | output |
* | --- |
* | "That photo is too large. Choose one of up to {size}." |
*
* @param {Settings_Photo_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo_too_large = /** @type {((inputs: Settings_Photo_Too_LargeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Photo_Too_LargeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Die foto is te groot. Kies er een van maximaal ${i?.size}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cette photo est trop lourde. Choisissez-en une de ${i?.size} maximum.`)
	return /** @type {LocalizedString} */ (`That photo is too large. Choose one of up to ${i?.size}.`)
});